import { Apartment, Business, LocationOn } from '@mui/icons-material'
import { Box, Link as MuiLink, Stack, Typography } from '@mui/material'

import type { Appointment } from '../../types.ts'
import { formatCustomerInfo } from '../formaters.ts'
import Header from '../Header'

interface Props {
  appointment: Appointment
}

export const SectionBuilding = ({ appointment }: Props) => {
  return (
    <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 45%' } }}>
      <Header label="Building Information" />

      <Stack spacing={2}>
        <Box display="flex" alignItems="center" gap={1}>
          <Business color="action" />
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Building ID
            </Typography>
            <Typography variant="body2">{appointment.buildingUUID}</Typography>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <LocationOn color="action" />
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Address
            </Typography>
            {formatCustomerInfo(appointment.customerAddress) === 'Not provided' ? (
              <Typography variant="body2" color="text.secondary">
                Not provided
              </Typography>
            ) : (
              <MuiLink
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  appointment.customerAddress
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'primary.main',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                <Typography variant="body2" component="span">
                  {formatCustomerInfo(appointment.customerAddress)}
                </Typography>
              </MuiLink>
            )}
          </Box>
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Apartment color="action" />
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              Residential Units
            </Typography>
            <Typography
              variant="body2"
              color={
                !appointment.residentialUnits || appointment.residentialUnits === 0
                  ? 'text.secondary'
                  : 'text.primary'
              }
            >
              {appointment.residentialUnits ? appointment.residentialUnits : 'Not available'}
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  )
}

export default SectionBuilding
